import { Flex, Grid, Text, useLayout } from '@approvalmax/ui/src/components';
import { Helmet } from 'react-helmet';
import { ContactSupportButton } from 'shared/components';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { KycStatusLayout } from '../../resources/components';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ hasHeader: true, hasDrawer: true });

    const company = useCompanyBasedOnUrl();

    return (
        <KycStatusLayout
            content={
                <>
                    <Helmet title={messages.pageTitle({ companyName: company?.displayName })} />

                    <Grid gap={16}>
                        <Text font='headline' fontSize='xxsmall' fontWeight='medium'>
                            {messages.title}
                        </Text>

                        <Text font='body' fontSize='medium' fontWeight='regular'>
                            {messages.unableToApprove}
                        </Text>

                        <Text font='body' fontSize='medium' fontWeight='regular'>
                            {messages.reasonsOfDenial}
                        </Text>

                        <Flex justifyContent='end'>
                            <ContactSupportButton />
                        </Flex>
                    </Grid>
                </>
            }
        />
    );
};

export default Page;
